module.exports = __webpack_public_path__ + "static/about-7e95dc9dfe5c1cc2b0033342d0afb5fc.jpg";